<template>
    <button type="button" class="icon-label-button" :class="{ 'icon-label-button--disabled': disabled }" :style="buttonStyle" :aria-disabled="String(disabled)" @click="handleClick">
        <i :class="[icon, 'i-andy-sm']" class="icon-label-button__icon" aria-hidden="true"></i>
        <span class="icon-label-button__label">{{ $t(label) }}</span>
    </button>
</template>

<script>
export default {
    name: 'IconLabelButton',
    props: {
        icon: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        backgroundColor: {
            type: String,
            default: '#ffffff'
        },
        textColor: {
            type: String,
            default: '#374673'
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        buttonStyle() {
            return {
                backgroundColor: this.backgroundColor,
                color: this.textColor
            }
        }
    },
    methods: {
        handleClick() {
            if (this.disabled) return
            this.$emit('click')
        }
    }
}
</script>

<style lang="scss" scoped>
.icon-label-button {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    padding: 8px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: opacity 0.2s ease;

    &:hover:not(.icon-label-button--disabled) {
        opacity: 0.85;
    }

    &--disabled {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;

        .icon-label-button__label {
            color: $inactive-dark;
        }
    }

    &__icon {
        flex-shrink: 0;
        color: $inactive-dark;
    }

    &__label {
        white-space: nowrap;
        font-family: $text-bold;
        font-size: 18px;
        font-style: normal;
        line-height: 20px;
    }
}
</style>
